module.exports = __webpack_public_path__ + "static/media/printer.c109a5ac.svg";